var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDailyEntery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M251.879 212.793c0-27.602-24.102-42.64-48-42.64-23.48 0-46.555 14.421-46.555 39.55 0 12.98 6.184 16.688 14.422 16.688 10.504 0 16.89-5.77 16.89-11.743 0-11.332 7.212-15.449 15.45-15.449 11.535 0 15.656 8.035 15.656 14.625 0 26.16-64.887 44.7-64.887 77.043v19.98c0 5.973 8.239 9.887 14.008 9.887h73.332c5.149 0 9.684-6.796 9.684-14.21 0-7.419-4.535-13.805-9.684-13.805h-53.968v-1.852c0-18.746 63.652-33.37 63.652-78.074zm0 0",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.066 320.734c8.036 0 16.067-3.296 16.067-9.886v-21.836h8.86c4.94 0 9.886-7.414 9.886-14.832 0-7.414-3.293-14.832-9.887-14.832h-8.86V244.93c0-6.797-8.03-9.684-16.066-9.684-8.03 0-16.066 2.887-16.066 9.684v14.418h-17.715l36.461-73.125c.617-1.446 1.027-2.68 1.027-3.914 0-7.418-10.503-12.157-16.062-12.157-5.152 0-10.305 2.266-13.395 8.243l-47.582 93.312c-4.05 7.426-.609 17.305 9.063 17.305H311v21.836c0 6.59 8.035 9.886 16.066 9.886zm0 0",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 236c-11.047 0-20 8.953-20 20 0 119.379-96.605 216-216 216-119.379 0-216-96.605-216-216 0-119.379 96.605-216 216-216 43.79 0 84.785 12.96 119.46 36h-21.976c-11.046 0-20 8.953-20 20s8.954 20 20 20h76c11.043 0 20-9.094 20-20V20c0-11.047-8.957-20-20-20-11.046 0-20 8.953-20 20v31.07C367.184 19.328 314.016 0 256 0 114.516 0 0 114.496 0 256c0 141.484 114.496 256 256 256 141.484 0 256-114.496 256-256 0-11.047-8.953-20-20-20zm0 0",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyEntery);
export default __webpack_public_path__ + "static/media/daily-entery.981acbf1e1e64e3857f3809491ac5532.svg";
export { ForwardRef as ReactComponent };